import { initSwipers } from './swipers';
import 'fslightbox';
import Lenis from 'lenis'
import { initLoadMore } from './load-more-media';

document.addEventListener('DOMContentLoaded', function () {

  document.body.classList.add('loaded');

  // Initialize
  initSwipers();
  initLoadMore();

  const header = document.querySelector('.header__container');

  window.addEventListener('scroll', () => {
    header.classList.toggle('header__container--is-scrolling', window.scrollY > 0);
  });

  const menuMobileButton = document.getElementById("menuMobileButton");
  const menu = document.getElementById("nav");

  menuMobileButton.addEventListener('click', function () {
    menuMobileButton.classList.toggle('is-active');
    menuMobileButton.setAttribute('aria-expanded', menuMobileButton.classList.contains('is-active'));
    menu.classList.toggle('is-active');
    document.body.classList.toggle('is-menu-open');
  });

});

const lenis = new Lenis({
  duration: 1.45,
  direction: 'vertical',
  gestureDirection: 'vertical',
  smooth: true,
  mouseMultiplier: 1,
  smoothTouch: false,
  touchMultiplier: 2,
  infinite: false,
});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

function preventLenisOnCookiebot() {
  const dialog = document.querySelector('#CybotCookiebotDialog');
  if (dialog) {
    dialog.setAttribute('data-lenis-prevent', '');
    return true;
  }
  return false;
}

const observer = new MutationObserver(() => {
  if (preventLenisOnCookiebot()) {
    observer.disconnect();
  }
});
observer.observe(document.body, { childList: true, subtree: true });

window.addEventListener('CookiebotOnDialogDisplay', preventLenisOnCookiebot);

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const content = document.querySelector('body');

if (content) {
  Array.from(content.querySelectorAll(
    '.editor h1, .editor h2, .editor h3, .editor h4, .editor h5, .editor h6, .editor .h1, .editor .h2, .editor .h3, .editor li, .editor p, .gsap'
  )).forEach((element) => {
    const delay = element.dataset.delay ? parseFloat(element.dataset.delay) : 0;
    gsap.from(element, {
      scrollTrigger: element,
      y: 40,
      opacity: 0,
      duration: 0.8,
      delay: delay,
    });
  });
}


const round = document.querySelector('.specializations-round');

if (round) {
  document.querySelectorAll('.specializations-list__link').forEach(link => {
    const imageUrl = link.dataset.image;

    link.addEventListener('mouseenter', () => {
      // tworzymy <img>
      const img = document.createElement('img');
      img.src = imageUrl;

      round.innerHTML = ''; // wyczyść poprzedni obrazek
      round.appendChild(img);

      // ustaw startowy stan animacji
      gsap.set(img, { opacity: 0, scale: 0.9 });

      // animacja pojawienia się
      gsap.to(img, {
        opacity: 1,
        scale: 1,
        duration: 0.4,
        ease: "power2.out"
      });
    });

    link.addEventListener('mouseleave', () => {
      const img = round.querySelector('img');
      if (!img) return;

      // animacja znikania
      gsap.to(img, {
        opacity: 0,
        scale: 1.1,
        duration: 0.3,
        ease: "power2.in",
        onComplete: () => {
          img.remove(); // usuń po animacji
        }
      });
    });
  });
}




const hero = document.querySelector(".block-hero");
const round2 = document.querySelector(".block-hero__round");

if (hero) {
  hero.addEventListener("mousemove", (e) => {
    const { left, top, width, height } = hero.getBoundingClientRect();

    // normalizujemy pozycję kursora w zakresie -1 do 1
    const x = ((e.clientX - left) / width - 0.5) * 100;
    const y = ((e.clientY - top) / height - 0.5) * 100;

    // animujemy delikatny ruch
    gsap.to(round2, {
      x: x * 0.3, // współczynnik "delikatności"
      y: y * 0.3,
      duration: 0.6,
      ease: "power2.out"
    });
  });
}



// Images parallax
gsap.utils.toArray('.image-ani').forEach(container => {
  const img = container.querySelector('img');

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      scrub: true,
      pin: false,
    }
  });

  tl.fromTo(img, {
    yPercent: -10,
    ease: 'none'
  }, {
    yPercent: 10,
    ease: 'none'
  });
});


// ANI CONTACT
const contactImage = document.querySelector('.block-contact__columns--image .img-wrap');

if (contactImage) {
  gsap.to(".block-contact__columns--image .img-wrap", {
    y: 90,
    ease: "none",
    scrollTrigger: {
      trigger: ".block-contact__columns",
      start: "top top",     // kiedy góra kolumn dotyka góry okna
      end: "center top",    // kiedy środek kolumn dotyka góry okna
      scrub: 1
    }
  });
}

const stickyScope = document.querySelector(".single__sticky-scope");

if (stickyScope) {
  ScrollTrigger.create({
    trigger: ".single__sticky-scope",
    start: `top-=160`,
    end: () => "+=" + (document.querySelector("#bg12").offsetHeight + document.querySelector("#bg123").offsetHeight - 230),
    pin: ".block-top-social",
    pinSpacing: false,
    scrub: true,
  });
}

const MAX_X = 46; // maks. przesunięcie w px w osi X
const MAX_Y = 42; // maks. przesunięcie w px w osi Y

document.querySelectorAll('.parallaxed').forEach(container => {
  const target = container.querySelector('.block-top__round');
  const targetBlue = container.querySelector('.animate-round--blue');
  const targetWhite = container.querySelector('.animate-round--white');

  if (!target && !targetBlue && !targetWhite) return;

  container.addEventListener('mouseenter', () => {
    [target, targetBlue, targetWhite].forEach(el => {
      if (!el) return;
      gsap.to(el, { scale: 1, duration: 0.25, ease: 'power2.out' });
    });
  });

  container.addEventListener('mousemove', e => {
    const rect = container.getBoundingClientRect();
    const nx = (e.clientX - rect.left) / rect.width - 0.5;
    const ny = (e.clientY - rect.top) / rect.height - 0.5;

    [target, targetBlue, targetWhite].forEach((el, i) => {
      if (!el) return;
      // Różny zakres ruchu, żeby efekt był ciekawszy
      const factor = i === 1 ? 0.8 : i === 2 ? 1.2 : 1;
      gsap.to(el, {
        x: nx * MAX_X * factor,
        y: ny * MAX_Y * factor,
        duration: 0.18,
        overwrite: true,
        ease: 'power2.out'
      });
    });
  });

  // NIE resetujemy pozycji przy opuszczeniu kontenera
  container.addEventListener('mouseleave', () => {
    [target, targetBlue, targetWhite].forEach(el => {
      if (!el) return;
      gsap.to(el, { scale: 1, duration: 0.35, ease: 'power3.out' });
    });
  });
});

// FAQ
document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".faq__single");

  items.forEach((item) => {
    const btn = item.querySelector(".faq__question");
    const answer = item.querySelector(".faq__answer");

    btn.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      // zamknij wszystkie
      items.forEach((el) => {
        el.classList.remove("active");
        el.querySelector(".faq__answer").style.maxHeight = null;
      });

      // jeśli kliknięty był zamknięty → otwórz go
      if (!isActive) {
        item.classList.add("active");
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });
  });
});


// KURSOR SPECJALIZACJE
document.addEventListener("DOMContentLoaded", () => {
  const cursor = document.querySelector(".cursor-image");
  const links = document.querySelectorAll(".specializations-list__item");

  if (!cursor) {
    console.warn("Brak elementu .cursor-image w DOM");
    return;
  }

  let hideTween = null; // zapamiętamy animację chowania

  // ruch kursora
  document.addEventListener("mousemove", (e) => {
    const rect = cursor.getBoundingClientRect();
    gsap.to(cursor, {
      x: e.clientX + 50,
      y: e.clientY - rect.height / 2,
      duration: 0.2,
      ease: "power3.out"
    });
  });

  links.forEach(link => {
    const imgUrl = link.dataset.image;

    link.addEventListener("mouseenter", () => {
      // jeśli trwa animacja chowania — zatrzymaj ją
      if (hideTween) {
        hideTween.kill();
        hideTween = null;
      }

      const img = document.createElement("img");
      img.src = imgUrl;

      cursor.innerHTML = "";
      cursor.appendChild(img);

      gsap.set(img, { opacity: 0, scale: 1 });

      gsap.to(cursor, {
        opacity: 1,
        scale: 1,
        duration: 0.3,
        ease: "power3.out"
      });

      gsap.to(img, {
        opacity: 1,
        duration: 0.3,
        ease: "power2.out"
      });
    });

    link.addEventListener("mouseleave", () => {
      const img = cursor.querySelector("img");
      if (!img) return;

      // zapisz tween, żeby można było go przerwać
      hideTween = gsap.to(cursor, {
        opacity: 0,
        scale: 0,
        duration: 0.6,
        ease: "power3.out",
        onComplete: () => {
          if (img && img.parentNode) img.remove();
          hideTween = null;
        }
      });
    });
  });
});


// WE ARE
document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".block-we-are");
  const list = section?.querySelector(".slogan ul");
  const items = list ? Array.from(list.querySelectorAll("li")) : [];

  if (!section || !list || items.length < 2) return;

  const line = items[0].getBoundingClientRect().height;

  list.style.height = `${line}px`;


  gsap.set(items, { y: (i) => i * line, opacity: 0.25, force3D: true });
  items[0].classList.add("active");
  gsap.set(items[0], { opacity: 1 });

  const STEP_SCROLL = 260;
  const steps = items.length - 1;

  let currentActive = 0;
  const setActive = (idx) => {
    if (idx === currentActive) return;
    items[currentActive].classList.remove("active");
    items[idx].classList.add("active");
    gsap.to(items[currentActive], { opacity: 0.25, duration: 0.2 });
    gsap.to(items[idx], { opacity: 1, duration: 0.2 });
    currentActive = idx;
  };

  const tl = gsap.timeline({
    defaults: { ease: "none" },
    scrollTrigger: {
      trigger: section,
      start: "top top",
      end: "+=" + (STEP_SCROLL * steps),
      pin: true,
      scrub: 0.5,
      snap: {
        snapTo: (value) => {
          return Math.round(value * steps) / steps;
        },
        duration: 0.25,
        ease: "power1.inOut"
      },
      onUpdate: (self) => {
        const idx = Math.max(0, Math.min(steps, Math.round(self.progress * steps)));
        setActive(idx);
      }
    }
  });

  tl.to(items, { y: (i) => (i - steps) * line });
});


// NUMBERS
document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const items = document.querySelectorAll(".block-numbers-list-item__nr");

  items.forEach((item) => {
    // Pobierz zawartość pola
    const text = item.textContent.trim();

    // Rozdziel liczby i sufiks (np. +, %, itp.)
    const match = text.match(/^(\d+)(.*)$/);
    if (!match) return;

    const number = parseInt(match[1], 10); // liczba
    const suffix = match[2] || "";          // reszta (np. % albo +)

    // Wyczyść element i zostaw pusty na start
    item.textContent = "0" + suffix;

    // Animacja GSAP
    gsap.fromTo(item,
      { innerText: 0 },
      {
        innerText: number,
        duration: gsap.utils.random(1.5, 3), // różne tempo dla każdego
        ease: "power1.out",
        snap: { innerText: 1 }, // zaokrąglenie do pełnych
        scrollTrigger: {
          trigger: ".block-numbers",
          start: "top bottom",  // jak sekcja dotknie górnej krawędzi okna
          once: true,
          //markers: document.body.classList.contains("logged-in"),
        },

        onUpdate: function () {
          item.textContent = Math.floor(item.innerText) + suffix;
        }
      }
    );
  });
});


/*
document.addEventListener("DOMContentLoaded", () => {
  if (document.body.classList.contains('home')) {
    console.log('Body ma klasę home!');

    const blocks = document.querySelectorAll("main > div");

    blocks.forEach((block, i) => {

      // normalny trigger dla każdej poza pierwszą
      if (i !== 0) {
        ScrollTrigger.create({
          trigger: block,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          //markers: true
        });
      }

      // 🔥 kluczowy efekt:
      // każda sekcja (poza pierwszą)
      // animuje poprzednią wolniej
      if (i > 0) {
        gsap.to(blocks[i - 1], {
          y: "50%", // 2x wolniej
          filter: "blur(5px)",
          opacity: 0.9,
          ease: "none",
          scrollTrigger: {
            trigger: block,
            start: "top bottom",
            end: "bottom top",
            scrub: true
          }
        });
      }

    });
  }
})*/
